<template>
  <div class="fluid" id="kecamatanList">
    <div>
      <div class="kecamatan-list-div">
        <v-card class="px-3 py-2">
          <v-row>
            <v-col
              cols="12"
              class="d-flex"
              style="position:relative;padding:0 20px;text-align:center;margin-top:20px;"
            >
              <h6 class="indigo--text" style="font-weight:bold;margin:auto;">
                KECAMATAN
              </h6>
            </v-col>
            <v-col cols="12">
              <div>
                <v-toolbar
                  class="kecamatan-list-toolbar-1"
                  flat
                  style="height: 60px; border-radius: 10px 10px 0 0"
                >
                  <div>
                    <div style="width: 120px">
                      <v-select
                        :disabled="selectedData.length === 0"
                        label="Action"
                        style="
                      position: relative;
                      top: 15px;
                      margin-left: 5px;
                      font-size: 12px;
                    "
                        v-model="actionValue"
                        :items="[
                          { id: 0, name: '' },
                          { id: 1, name: 'Delete' }
                        ]"
                        item-text="name"
                        item-value="id"
                        outlined
                        return-id
                        dense
                        @change="action"
                      ></v-select>
                    </div>
                  </div>
                  <v-dialog v-model="dialog" width="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        elevation="1"
                        color="indigo"
                        class="indigo--text font-weight-bold"
                        style="font-size:12px;margin-left:20px;"
                        @click="addProvinsi"
                        :disabled="loading"
                      >
                        Tambah kecamatan
                      </v-btn>
                    </template>

                    <v-form
                      :disabled="loading"
                      ref="entryForm"
                      @submit.prevent="submit"
                      style="position: relative;"
                    >
                      <v-card>
                        <v-card-title class="text-h5 grey lighten-2">
                          Tambah Kecamatan
                        </v-card-title>

                        <v-card-text class="d-flex justify-center align-center">
                          <v-col
                            md="12"
                            style="padding: 0; position:relative; top:20px;"
                          >
                            <div style="padding: 0 10px">
                              <v-col cols="12" style="padding: 0">
                                <p
                                  class="text-left"
                                  style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                                >
                                  Nama Kecamatan
                                </p>
                              </v-col>
                              <v-col cols="12" style="padding: 0;">
                                <v-text-field
                                  v-model="form.name"
                                  outlined
                                  :rules="nameRules"
                                />
                              </v-col>
                              <v-col cols="12" style="padding: 0">
                                <p
                                  class="text-left"
                                  style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                                >
                                  Kota
                                </p>
                              </v-col>
                              <v-col cols="12" style="padding: 0;">
                                <v-autocomplete
                                  :items="kota"
                                  item-text="name"
                                  item-value="id"
                                  return-object
                                  outlined
                                  dense
                                  style="margin: 0;height: 55px;"
                                  v-model="form.kota"
                                  :rules="kotaRules"
                                ></v-autocomplete>
                              </v-col>
                            </div>
                          </v-col>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-btn
                            color="error"
                            text
                            outlined
                            @click="close"
                            :loading="loading"
                          >
                            Batal
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            type="submit"
                            text
                            outlined
                            :loading="loading"
                          >
                            Simpan
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-form>
                  </v-dialog>
                  <div class="kecamatan-list-toolbar-1">
                    <v-text-field
                      v-model="paramAPI.keyword"
                      label="cari kecamatan"
                      type="search"
                      outlined
                      dense
                      append-icon="mdi-magnify"
                      style="position: relative; top: 15px; width: 10px;
                        margin-left: 10px;"
                      @keyup.enter="searchEnter"
                      :disabled="loading"
                    ></v-text-field>
                    <div
                      style="margin-left:20px;display:flex;justify-content:center;align-items:center;"
                    >
                      <v-btn
                        rounded
                        outlined
                        small
                        elevation="1"
                        color="indigo"
                        class="indigo--text"
                        style="font-size:12px;"
                        @click="searchEnter"
                        :disabled="loading"
                      >
                        search
                      </v-btn>
                    </div>
                  </div>
                </v-toolbar>
              </div>
              <v-toolbar
                class="kecamatan-list-toolbar-2"
                flat
                style="
                  height: 60px;
                  border-radius: 10px 10px 0 0;
                  border-bottom: 1px solid #e0e0e0;
                "
              >
                <v-text-field
                  v-model="paramAPI.keyword"
                  label="Search here"
                  type="search"
                  outlined
                  dense
                  :disabled="loading"
                  style="position: relative; top: 15px; width: 10px"
                ></v-text-field>
              </v-toolbar>
            </v-col>

            <v-col cols="12">
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                height="60vh"
                v-model="selectedData"
                :headers="headers"
                style="cursor: pointer;"
                :items="result"
                :loading="loading"
                @click:row="rowClick"
                item-key="id"
                show-select
                :single-select="true"
                :options.sync="options"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                }"
                :server-items-length="totalData"
                @update:page="updatePage"
                @update:items-per-page="updateItemPerPage"
              >
                <template v-slot:[`item.name`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ item.name }}
                  </div>
                </template>
                <template v-slot:[`item.kota`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ item.kota.name }}
                  </div>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  <div
                    style="font-size:12px; padding: 0; display: flex; flex-direction: row"
                  >
                    {{ convertDate(item.created_at) }}
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../../services/buildType'
export default {
  name: 'kota',
  data: () => ({
    dialog: false,
    hrApi: buildType.apiURL('hr'),
    build: process.env.VUE_APP_BUILD_TYPE,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      status: '',
      sortBy: 'name',
      sortType: 'asc',
      itemsPerPage: 10,
      kota_id: null
    },
    totalData: 0,

    options: {
      page: 1,
      itemsPerPage: 10,
      sortDesc: []
    },
    actionValue: 0,
    headers: [
      {
        text: 'Kecamatan',
        value: 'name',
        align: 'left',
        sortable: false
      },
      {
        text: 'Kota',
        value: 'kota',
        align: 'left',
        sortable: false
      },
      {
        text: 'Tgl. Buat',
        value: 'created_at',
        align: 'left',
        sortable: false
      },
      {
        text: 'Dibuat Oleh',
        value: 'created_by_name',
        align: 'left',
        sortable: false
      }
    ],
    result: [],
    kota: [
      {
        id: 1,
        name: 'Jakarta'
      },
      {
        id: 2,
        name: 'Bogor'
      },
      {
        id: 3,
        name: 'Depok'
      },
      {
        id: 4,
        name: 'Tangerang'
      },
      {
        id: 5,
        name: 'Bekasi'
      }
    ],
    selectedData: [],
    loading: false,
    form: {
      act: 'add',
      id: '',
      name: '',
      kota: null
    },
    nameRules: [],
    kotaRules: []
  }),

  async mounted() {
    // this.paramAPI.company_id = this.getUserProfile.employee.company_id
    await this.getDataFromApi()
    this.setAction()
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  methods: {
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise(resolve => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then(r => {
            resolve(r)
          })
      })
    },
    close() {
      this.nameRules = []
      this.form = {
        act: 'add',
        id: '',
        name: '',
        kota: null
      }
      this.dialog = false
    },
    action(event) {
      switch (event) {
        case 1:
          this.delete()
          break
      }
    },
    searchEnter() {
      this.getDataFromApi()
    },
    setAction() {
      this.actionValue = 0
      this.selectedData = []
    },

    async getDataFromApi() {
      this.loading = true
      await this.initDataTable().then(data => {
        setTimeout(() => {
          this.result = data.data
          this.totalData = data.total_record
          this.loading = false
        }, 2000)
      })
    },
    async initDataTable() {
      return await new Promise(resolve => {
        // axios
        //   .get(
        //     `${this.hrApi}.../list?keyword=${this.paramAPI.keyword}&order_by=${
        //       this.paramAPI.sortBy
        //     }&order_type=${this.paramAPI.sortType}&offset=${this.paramAPI
        //       .offset * this.paramAPI.limit}&limit=${this.paramAPI.limit}`
        //   )
        //   .then(res => {
        //     resolve(res.data)
        resolve({
          data: [
            {
              id: 123,
              name: 'Cibinong',
              kota: {
                id: 2,
                name: 'Bogor'
              },
              created_at: '01-12-2021',
              created_by_name: 'Arif Rahman'
            }
          ],
          total_record: 1
        })
        //   })
        //   .catch(err => {
        //     console.log(err)
        //   })
      })
    },
    addProvinsi() {
      this.form.act = 'add'
      setTimeout(() => {
        this.dialog = true
      }, 300)
    },
    rowClick(pItem) {
      this.form.act = 'update'
      this.form.id = pItem.id
      this.form.name = pItem.name
      this.form.kota = pItem.kota
      setTimeout(() => {
        this.dialog = true
      }, 300)
    },
    async delete() {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async res => {
        if (res.isConfirmed) {
          this.loading = true
          setTimeout(() => {
            // await axios
            //   .delete(`${this.hrApi}.../delete/${this.selectedData[0].id}`)
            //   .then(async res => {
            this.result.splice(
              this.result.findIndex(x => x.id === this.selectedData[0].id),
              1
            )

            this.actionValue = 0
            this.selectedData = []
            //     this.showMsgDialog('success', res.data.status_msg, 'false')
            //     await this.getDataFromApi()
            //   })
            //   .catch(err => {
            //     console.log(err)
            //   })
            this.loading = false
          }, 2000)
        } else {
          this.actionValue = 0
        }
      })
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },

    submit() {
      this.nameRules = [v => !!v || 'Name is required']
      this.kotaRules = [v => !!v || 'Kota is required']
      const self = this
      setTimeout(function() {
        if (self.$refs.entryForm.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      const form = {
        act: this.form.act,
        name: this.form.name,
        kota: this.form.kota
      }
      if (this.form.act === 'update') {
        Object.assign(form, { id: this.form.id })
      }
      if (this.form.act === 'add') {
        Object.assign(form, {
          id: Math.floor(Math.random() * 1000000)
        })
      }
      this.save(form)
    },
    async save(form) {
      this.loading = true
      // await axios
      //   .post(`${this.hr}.../save`, form)
      //   .then(async res => {
      //     if (res.data.status_code !== '-99') {
      setTimeout(() => {
        const payload = {
          id: form.id,
          name: form.name,
          kota: form.kota,
          created_at: new Date().toLocaleDateString(),
          created_by_name: 'Arif Rahman'
        }

        if (form.act === 'add') {
          this.result.push(payload)
        }

        if (form.act === 'update') {
          this.result.splice(
            this.result.findIndex(x => x.id === form.id),
            1,
            payload
          )
        }
        this.showMsgDialog('success', 'res.data.status_msg', false)
        this.loading = false
        //       await this.getDataFromApi()
        this.close()
      }, 2000)
      //     } else {
      //       if (res.data.status_msg === 'Parameter value has problem') {
      //         this.showMsgDialog(
      //           'error',
      //           'Invalid input, Parameter value has problem',
      //           false
      //         )
      //       } else {
      //         this.showMsgDialog('error', res.data.status_msg, false)
      //       }
      //     }
      //   })
      //   .catch(err => {
      //     this.showMsgDialog(
      //       'error',
      //       err
      //         ? 'Something went wrong, Please contact an admin!'
      //         : 'Something went wrong, Please contact an admin!',
      //       false
      //     )
      //   })
    },

    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleDateString()
        return local
      }
    }
  }
}
</script>
<style lang="scss">
#kecamatanList {
  position: relative;
  .kecamatan-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .kecamatan-list-toolbar-1 {
      .kecamatan-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .kecamatan-list-toolbar-2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #kecamatanList {
    .kecamatan-list-div {
      .kecamatan-list-toolbar-1 {
        .kecamatan-list-toolbar-1 {
          display: none;
        }
      }
      .kecamatan-list-toolbar-2 {
        display: block;
      }
    }
  }
}
</style>
